var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal right-modal",
      attrs: {
        name: "historyModal",
        width: "50%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minHeight: 900
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v("Change History")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              },
              mouseover: function($event) {
                _vm.isHoverClose = true
              },
              mouseleave: function($event) {
                _vm.isHoverClose = false
              }
            }
          },
          [
            !_vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close.svg"),
                    alt: "close"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isHoverClose
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/img/info-modal-close-hover.svg"),
                    alt: "close"
                  }
                })
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        _vm._l(_vm.getEventHistory, function(history) {
          return _c(
            "div",
            [_c("HistoryModalSection", { attrs: { history: history } })],
            1
          )
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c76d03f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c76d03f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/HistoryModal.vue
// module id = 1457
// module chunks = 1